import { queryKeyPrefix } from 'src/features/tanStackQuery/queryKeyPrefix'

const prefix = queryKeyPrefix.shipmentReadinessOverview

export const queryKeys = {
  url: [...prefix, 'url'],
}
